import React from "react"
import PropTypes from "prop-types"

import TrialInfoForm from "app/components/subscriptions/trial/trial_info_form.js"

import "./upsell.scss"

const Upsell = ({
  iftttSvgUrl,
  onSkip,
  onTryProClick,
  trialConfig,
  proBadgeSvgUrl,
  handleErrorFlow,
}) => {
  return (
    <>
      <header styleName="onboarding-header">
        <div styleName="spacer" />
        <h1>
          <img
            src={iftttSvgUrl}
            alt="Example Applet: Post your Tweets to Facebook"
          />
          <img
            src={proBadgeSvgUrl}
            alt="Example Applet: Post your Tweets to Facebook"
          />
        </h1>
        <div styleName="spacer" />
      </header>

      <div styleName="container">
        <TrialInfoForm
          {...trialConfig}
          handleSuccessFlow={onTryProClick}
          handleErrorFlow={handleErrorFlow}
        />
        <a onClick={onSkip} styleName="skip-pro-link">
          Not now
        </a>
      </div>
    </>
  )
}

Upsell.propTypes = {
  iftttSvgUrl: PropTypes.string,
  onSkip: PropTypes.func,
  onTryProClick: PropTypes.func,
  handleErrorFlow: PropTypes.func,
  proBadgeSvgUrl: PropTypes.string,
  trialConfig: PropTypes.shape({
    assets: PropTypes.shape({
      proIllustration: PropTypes.string.isRequired,
    }),
    planId: PropTypes.string.isRequired,
    productId: PropTypes.string.isRequired,
    urls: PropTypes.shape({
      createStripeCustomerUrl: PropTypes.string.isRequired,
      subscriptionsPath: PropTypes.string.isRequired,
    }),
  }),
}

export default Upsell
